(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TalknApps", [], factory);
	else if(typeof exports === 'object')
		exports["TalknApps"] = factory();
	else
		root["TalknApps"] = factory();
})(globalThis, () => {
return 